// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

// Redux
import { connect } from 'react-redux';
import { getAssociateData } from '../../redux/actions/profile';
import { getRegistrationPaymentList, updateFinanceOperationData, updateGeneratedPaymentRef } from '../../redux/actions/finance';
import FinancialService from '../../redux/services/finance';
import PaymentService from '../../redux/services/payment';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './finance.scss';

// Utils
import { COMPANY_DATA, PAYMENT_CHANNEL_BANK_TRANSFER, PAYMENT_CHANNEL_CREDIT_CARD, PAYMENT_CHANNEL_MB, PAYMENT_CHANNEL_MBWAY, PAYMENT_METHOD_CC, PAYMENT_METHOD_MB, PAYMENT_METHOD_MBWAY, PAYMENT_STATE_PAYED, PAYMENT_STATE_WAITING_PAYMENT, PAYMENT_TYPE_REGISTRATION, PAYMENT_TYPE_REGISTRATION_FINAL, PERSONAL_COMPANY_DATA, PERSONAL_DATA } from '../../common/constants';
import { getPrettyDate } from '../../common/utils/date-utils';
import { WORLD_LIST } from '../../common/lists/countries';
import { validateNIF } from '../../common/utils/validation-utils';
import { getCreditCardFormConfig } from '../../common/utils/credit-card-utils';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

class FinancePage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            generatePayment: false,
            paymentGenerated: false,
            selectedPaymentMethod: 0,
            mobilePhoneNumber: null,
            mobilePhoneNumberPrefix: "351",
            mbEntity: "",
            mbReference: "",
            mbValue: "",
            mbDueDate: "",
            validPaymentMethod: true,
            validMobilePhoneNumber: true,
            validMobilePhoneNumberPrefix: true,
            paymentLoading: false,
            checkoutPaymentRef: null,
            // Invoice data management
            validCompanyEntity: true,
            validCompanyNipc: true,
            // SIBS credit card checkout
            showCardForm: false
        }
    }

    componentDidMount() {
        // Check if the page was called from SIBS
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let formIdParam = params.get('id');

        if(formIdParam === null) {
            this.props.getAssociateData(this.props.registrationRef);
            this.props.getRegistrationPaymentList(this.props.registrationRef);

            this.props.updateFinanceOperationData({
                selectedPaymentMethod: null,
                nIPC: null,
                nIPCCountry: { code: "Portugal", name: "Portugal" },
                entity: null,
                selectedInvoiceData: PERSONAL_DATA
            });
        }
        else {
            FinancialService.getCreditCardCheckoutStatus(formIdParam)
            .then((response) => {
                let successCodesRegex = new RegExp('^(000\.000\.|000\.100\.1|000\.[36])');

                // Confirm if payment was successful
                if(successCodesRegex.test(response.checkout.result.code)) {
                    this.generatePayment();
                }
                else {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.credit-card-error"), life: 5000 });
                }
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.error"), life: 3000 });
            });

            this.setState({
                showCardForm: false,
                generatePayment: true
            });
        }
    }

    downloadInvoice(invoiceRef) {
      FinancialService.generateInvoicePdf(invoiceRef)
        .then((response) => {
            window.open(response.output.pdfUrl, '_blank');
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.error"), life: 3000 });
        });
    }

    priceBodyTemplate(rowData) {
        return rowData.price + " €";
    }

    dateBodyTemplate(rowData, column) {
        return rowData[column] !== undefined && rowData[column] !== null ? rowData[column].replace('T',' ') : "";
    }

    stateBodyTemplate(rowData) {
        if(rowData.state === PAYMENT_STATE_PAYED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("finance.form.payed")}</span>;
        }
        else if(rowData.state === PAYMENT_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("finance.form.waiting-payment")}</span>;
        }
        else {
          return <span className={'state-badge'} style={{background: '#C63737', color: '#FFFFFF'}}>{this.props.t("finance.form.cancelled")}</span>;
        }
    }

    paymentChannelBodyTemplate(rowData) {
        if(rowData.channel === PAYMENT_CHANNEL_MB) {
            return this.props.t("finance.form.payment-channel-mb");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_MBWAY) {
            return this.props.t("finance.form.payment-channel-mbway");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_CREDIT_CARD) {
            return this.props.t("finance.form.payment-channel-credit-card");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_BANK_TRANSFER) {
            return this.props.t("finance.form.payment-channel-bank-transfer");
        }
        else {
            return this.props.t("finance.form.payment-channel-direct-debit");
       }
    }

    paymentTypeBodyTemplate(rowData) {
        if(rowData.type === PAYMENT_TYPE_REGISTRATION) {
            return this.props.t("finance.form.payment-type-registration");
        }
        else {
            return this.props.t("finance.form.payment-type-enrollment");
       }
    }

    invoiceDownloadBodyTemplate(rowData) {
        return <Button icon="pi pi-download" onClick={() => this.downloadInvoice(rowData.invoiceRef)} />;
    }

    processRegistrationPayment() {
        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC) {
            this.generateCreditCardCheckout();
        }
        else {
            this.generatePayment(this.props.operation.selectedPaymentMethod);
        }
    }

    generatePayment(selectedPaymentMethod = PAYMENT_METHOD_CC) {
        let formValid = true;

        if(selectedPaymentMethod !== 0) {

            let validEntity = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
            let validNipc = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
    
            if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
                validEntity = (this.props.operation.entity !== null && this.props.operation.entity !== "");
                validNipc = (this.props.operation.nIPC !== null && this.props.operation.nIPC !== "") && validateNIF(this.props.operation.nIPC);
    
                this.setState({
                    validCompanyEntity: validEntity,
                    validCompanyNipc: validNipc
                });
            }

            if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
                let validMobilePhoneNumber = (this.state.mobilePhoneNumber !== null && this.state.mobilePhoneNumber !== "");

                if(validMobilePhoneNumber) {
                    if(this.state.mobilePhoneNumber.slice(0, 3) === "351") {
                        validMobilePhoneNumber = (this.state.mobilePhoneNumber.length === 12);
                    }
                }

                this.setState({
                    validPaymentMethod: true,
                    validMobilePhoneNumber: validMobilePhoneNumber,
                    validMobilePhoneNumberPrefix: this.state.mobilePhoneNumberPrefix !== "",
                });

                formValid = (validMobilePhoneNumber && this.state.mobilePhoneNumberPrefix !== "" && validEntity && validNipc);
            }
            else {
                if(validEntity && validNipc) {
                    this.setState({
                        validPaymentMethod: true,
                        validMobilePhoneNumber: true,
                        validMobilePhoneNumberPrefix: true,
                        mobilePhoneNumber: null,
                        mobilePhoneNumberPrefix: null
                    });
    
                    formValid = true;
                }
                else {
                    formValid = false;
                }
            }
        }
        else {
            this.setState({
                validPaymentMethod: false
            });

            formValid = false;
        }

        if(formValid) {
            this.submitPayment(selectedPaymentMethod);
        }
    }

    submitPayment(selectedPaymentMethod) {
        let payment = {
            registrationRef: this.props.registrationRef,
            paymentType: PAYMENT_TYPE_REGISTRATION_FINAL,
            paymentChannel: selectedPaymentMethod,
            repeated: false,
            paymentRef: null,
            mobilePhoneNumber: this.state.mobilePhoneNumberPrefix + "#" + this.state.mobilePhoneNumber,
            company: null
        };

        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC)
        {
            payment.paymentRef = this.props.generatedPaymentRef;
        }

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            payment.company = {
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry.code
            }
        }

        this.setState({
            paymentLoading: true
        });

        PaymentService.generateRegistrationPayment(payment)
        .then((response) => {

            this.setState({
                paymentLoading: false
            });

            // If MB present payment data
            if(selectedPaymentMethod === PAYMENT_METHOD_MB) {
                this.setState({
                    mbEntity: response.paymentData.entity,
                    mbReference: response.paymentData.reference,
                    mbValue: response.paymentData.amount,
                    mbDueDate: getPrettyDate(response.paymentData.dueDate),
                    paymentGenerated: true
                });
            }
            else {
                this.setState({
                    paymentGenerated: true
                });
            }
        })
        .catch(error => {
            this.setState({
                paymentLoading: false
            });

            if(selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
                this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.mbway-error"), life: 5000 });
            }
            else {
                this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.error"), life: 3000 });
            }
        });
    }

    updatePaymentMethod(paymentMethod) {
        this.props.updateFinanceOperationData({
            selectedPaymentMethod: paymentMethod,
            entity: this.props.operation.entity,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            selectedInvoiceData: this.props.operation.selectedInvoiceData
        });
    }

    updateInvoiceData(invoiceData) {
        this.props.updateFinanceOperationData({
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            entity: this.props.operation.entity,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            selectedInvoiceData: invoiceData
        });
    }

    updateCompanyInvoiceData(column, value) {
        if(column === "companyEntity") {
            this.props.updateFinanceOperationData({
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: value,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }

        if(column === "companyNipc") {
            this.props.updateFinanceOperationData({
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: this.props.operation.entity,
                nIPC: value,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }

        if(column === "companyNipcCountry") {
            this.props.updateFinanceOperationData({
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: value,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }
    }

    generateCreditCardCheckout() {
        FinancialService.generateCreditCardCheckout({
            paymentType: PAYMENT_TYPE_REGISTRATION_FINAL,
            email: this.props.associate.personalData.email
        })
        .then((response) => {
            const script1 = document.createElement("script");
            script1.innerHTML = getCreditCardFormConfig(this.props.associate.personalData.city,
                                                        this.props.associate.personalData.cP4,
                                                        this.props.associate.personalData.cP3,
                                                        this.props.associate.personalData.addressLine1,
                                                        this.props.associate.personalData.addressLine2,
                                                        this.props.t("quotes.messages.invalid-holder"));
            
            script1.async = true;

            const script2 = document.createElement("script");
            script2.src = process.env.REACT_APP_SIBS_WIDGET_URL + response.checkout.id;
            script2.async = true;

            document.body.appendChild(script1);
            document.body.appendChild(script2);

            this.setState({
                showCardForm: true
            });

            this.props.updateGeneratedPaymentRef(response.paymentRef);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
    }

    render() {

    return (
        <div>
            <PageTitleComponent title={this.props.t("finance.title")} />
            <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                <div className='col-1'></div>
                <div className="col-10">
                    {
                        this.state.paymentLoading ? 
                            <i className="mgt-200 pi pi-spin pi-spinner" style={{ fontSize: '4rem', color: '#0073aa' }}></i>
                            :
                            <div className="card mgt-20">
                            {
                                this.props.registrationApproved && this.props.payments !== null ? 
                                    <DataTable value={this.props.payments} paginator className="p-datatable-gridlines" showGridlines rows={10} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("finance.messages.no-payments")}>
                                        <Column field="type" header={this.props.t("finance.form.type-header")} body={(data) => this.paymentTypeBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                        <Column field="price" header={this.props.t("finance.form.price-header")} body={(data) => this.priceBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        <Column field="creationDate" header={this.props.t("finance.form.creation-date-header")} body={(data) => this.dateBodyTemplate(data, 'creationDate')} style={{ minWidth: '12rem' }} />
                                        { /* <Column field="dueDate" header={this.props.t("finance.form.due-date-header")} body={(data) => this.dateBodyTemplate(data, 'dueDate')} style={{ minWidth: '12rem' }} /> */ }
                                        <Column field="paymentDate" header={this.props.t("finance.form.payment-date-header")} body={(data) => this.dateBodyTemplate(data, 'paymentDate')} style={{ minWidth: '12rem' }} />
                                        <Column field="channel" header={this.props.t("finance.form.channel-header")} body={(data) => this.paymentChannelBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                        <Column field="state" header={this.props.t("finance.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                        <Column field="invoiceRef" header={this.props.t("finance.form.invoice-header")} body={(data) => this.invoiceDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                    </DataTable>
                                : null
                            }
                            {
                                this.props.mbPending ?
                                    <>
                                        <div className="col-12 t-align-center mgt-20">
                                            <p><i className="pi pi-exclamation-circle" style={{ fontSize: '2rem', color:'orange' }}></i></p>
                                            <span style={{fontSize:'15px'}}>{this.props.t("finance.form.pending-mb")}</span>
                                        </div> 
                                    </>
                                    : null
                            }
                            {
                                this.props.mbwayPending ?
                                    <>
                                        <div className="col-12 t-align-center mgt-20">
                                            <p><i className="pi pi-exclamation-circle" style={{ fontSize: '2rem', color:'orange' }}></i></p>
                                            <span style={{fontSize:'15px'}}>{this.props.t("finance.form.pending-mb-way")}</span>
                                        </div> 
                                    </>
                                    : null
                            }
                            {
                                !this.props.mbPending && !this.props.mbwayPending && !this.props.registrationApproved ?
                                    <>
                                    {
                                        !this.state.paymentGenerated ?
                                            <div className="col-12 t-align-left" style={{fontSize: "14px"}}>
                                                <p>{this.props.t("finance.form.accepted-registration")}</p>
                                            </div> 
                                            : null
                                    }
                                    {
                                        this.state.generatePayment ?
                                            <div className="grid">
                                                {
                                                    !this.state.paymentGenerated ?
                                                        <div className='col-3'>
                                                            <div className='mgt-20'>
                                                                <div className="field-radiobutton">
                                                                    <RadioButton inputId="ref-mb" name="payment-method" value={PAYMENT_METHOD_MB} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MB)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB} />
                                                                    <label style={{fontSize: "14px"}} htmlFor="ref-mb">{this.props.t("finance.form.payment-methods.mb")}</label>
                                                                </div>
                                                                <div className="field-radiobutton">
                                                                    <RadioButton inputId="cc" name="payment-method" value={PAYMENT_METHOD_CC} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_CC)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC} />
                                                                    <label style={{fontSize: "14px"}} htmlFor="cc">{this.props.t("finance.form.payment-methods.cc")}</label>
                                                                </div>
                                                                <div className="field-radiobutton">
                                                                    <RadioButton inputId="mb-way" name="payment-method" value={PAYMENT_METHOD_MBWAY} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MBWAY)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY} />
                                                                    <label style={{fontSize: "14px"}} htmlFor="mb-way">{this.props.t("finance.form.payment-methods.mbway")}</label>
                                                                </div>
                                                                { !this.state.validPaymentMethod ? 
                                                                    <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                        : null
                                                }
                                                {
                                                    this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY && !this.state.paymentGenerated ?
                                                        <>
                                                            <div className='col-9 t-align-left mgt-20'>
                                                                <p>{this.props.t("quotes.dialog.mbway")}</p>
                                                            </div> 
                                                            <div className='col-3 t-align-left mgt-10'></div>
                                                            <div className='col-3 t-align-left mgt-10'>
                                                                <label className='mgr-10' htmlFor="mobile-number-prefix">{this.props.t("quotes.dialog.mobile-number-prefix")}</label>
                                                                <InputText value={this.state.mobilePhoneNumberPrefix} className={!this.state.validMobilePhoneNumberPrefix ? "p-invalid" : null} id="mobile-number-prefix" type="number" style={{width:"80px"}} onChange={(evt) => this.setState({mobilePhoneNumberPrefix: evt.target.value})} />
                                                                { this.state.validMobilePhoneNumberPrefix ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                            </div> 
                                                            <div className='col-6 t-align-left mgt-10'>
                                                                <label className='mgr-10' htmlFor="mobile-number">{this.props.t("quotes.dialog.mobile-number")}</label>
                                                                <InputText value={this.state.mobilePhoneNumber} className={!this.state.validMobilePhoneNumber ? "p-invalid" : null} id="mobile-number" type="number" onChange={(evt) => this.setState({mobilePhoneNumber: evt.target.value})} />
                                                                { this.state.validMobilePhoneNumber ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                            </div> 
                                                        </>
                                                        :
                                                        <div className='col-9 t-align-left mgt-20'></div>
                                                }
                                                {
                                                    !this.state.paymentGenerated ?
                                                        <div className='col-12 t-align-left mgt-10'>
                                                            <div className='grid'>
                                                                <div className='col-12 t-align-left mgt-10'>
                                                                    <b style={{fontSize: "14px"}}>{this.props.t("finance.form.invoice-data")}</b>
                                                                    <div className="field-radiobutton mgt-10">
                                                                        <RadioButton inputId="personal-data" name="invoice-data" value={PERSONAL_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_DATA} />
                                                                        <label htmlFor="personal-data">{this.props.t("finance.form.my-invoice-data")}<b>{this.props.t("finance.form.name-nif").replace("{0}", this.props.associate.personalData.name).replace("{1}", this.props.associate.personalData.nif)}</b></label>
                                                                    </div>
                                                                    <div className="field-radiobutton">
                                                                        <RadioButton inputId="personal-company-data" name="invoice-data" value={PERSONAL_COMPANY_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA} />
                                                                        <label htmlFor="personal-company-data">{this.props.t("finance.form.personal-company-invoice-data")}</label>
                                                                    </div>
                                                                    <div className="field-radiobutton">
                                                                        <RadioButton inputId="company-data" name="invoice-data" value={COMPANY_DATA} onChange={(e) => this.updateInvoiceData(COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === COMPANY_DATA} />
                                                                        <label htmlFor="company-data">{this.props.t("finance.form.other-company-invoice-data")}</label>
                                                                    </div>
                                                                </div> 
                                                                {
                                                                    this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA ?
                                                                        <>
                                                                            <div className='col-12 t-align-left'>
                                                                                <label className='mgr-10' htmlFor="company-entity">{this.props.t("finance.form.company-entity")}</label>
                                                                                <InputText value={this.props.operation.entity} className={!this.state.validCompanyEntity ? "p-invalid" : null} id="company-entity" style={{width: "350px", marginLeft:"20px"}} type="text" onChange={(evt) => this.updateCompanyInvoiceData("companyEntity", evt.target.value)} />
                                                                                { this.state.validCompanyEntity ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                            </div>
                                                                            <div className='col-3 t-align-left mgt-10'> 
                                                                                <label className='mgr-10' htmlFor="company-nipc">{this.props.t("finance.form.company-nipc")}</label>
                                                                                <InputText value={this.props.operation.nIPC} className={!this.state.validCompanyNipc ? "p-invalid" : null} id="company-nipc" type="text" style={{width:"120px"}} onChange={(evt) => this.updateCompanyInvoiceData("companyNipc", evt.target.value)} />
                                                                                { this.state.validCompanyNipc ? null : <p><small className="p-error">{this.props.t("finance.messages.invalid-nif")}</small></p>  }
                                                                            </div> 
                                                                            <div className='col-3 t-align-left mgt-10'>
                                                                                <label className='mgr-10' htmlFor="nipc-country">{this.props.t("finance.form.company-nipc-country")}</label>
                                                                                <Dropdown id="nipc-country" style={{width:"170px"}} value={this.props.operation.nIPCCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateCompanyInvoiceData("companyNipcCountry", evt.value)}></Dropdown>
                                                                            </div>
                                                                        </>
                                                                        : null
                                                                } 
                                                            </div>
                                                        </div> 
                                                        :
                                                        <div className='col-9 t-align-left mgt-20'></div>
                                                }
                                                {
                                                    this.state.showCardForm ? 
                                                        <div className="col-12 t-align-left mgt-10">
                                                            <form action={process.env.REACT_APP_BASE_ADDRESS + "/finance"} className="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                                        </div> 
                                                    : null
                                                }
                                                {
                                                    this.state.showCardForm ?
                                                        <div className="col-6 t-align-left mgt-10">
                                                            <Button className='p-button-danger' label={this.props.t("general.cancel")} onClick={() => this.setState({showCardForm: false })} />
                                                        </div>  
                                                        : null
                                                }
                                                {
                                                    this.state.paymentGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB ?
                                                        <>
                                                            <div className="col-12 t-align-center mgt-20">
                                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                                <span style={{fontSize:'15px'}}>{this.props.t("finance.form.success-mb")}</span>
                                                            </div> 
                                                            <div className="col-12 t-align-left mgt-20">
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("finance.form.mb.entity")} </b>{this.state.mbEntity}</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("finance.form.mb.reference")} </b>{this.state.mbReference}</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("finance.form.mb.value")} </b>{this.state.mbValue} €</p>
                                                                <p style={{fontSize:'13px'}}><b>{this.props.t("finance.form.mb.due-date")} </b>{this.state.mbDueDate}</p>
                                                            </div>   
                                                        </>
                                                        : null
                                                }
                                                {
                                                    this.state.paymentGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                        <>
                                                            <div className="col-12 t-align-center mgt-20">
                                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                                <span style={{fontSize:'15px'}}>{this.props.t("finance.form.success-mb-way")}</span>
                                                            </div> 
                                                        </>
                                                        : null
                                                }
                                                {
                                                    this.state.paymentGenerated === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ?
                                                        <div className="col-12 t-align-center mgt-10">
                                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                            <span style={{fontSize:'15px'}}>{this.props.t("finance.form.success-payment")}</span>
                                                        </div>   
                                                        : null
                                                }
                                                {
                                                    !this.state.paymentGenerated && this.state.showCardForm === false ?
                                                        <div className="col-2 t-align-left mgt-20">
                                                            <Button className='p-3 w-full mt-auto p-button-success' label={this.props.t("finance.form.confirm")} onClick={() => this.processRegistrationPayment()} />
                                                        </div>
                                                        : null
                                                }
                                                {
                                                    !this.state.paymentGenerated && this.state.showCardForm === false ?
                                                        <div className="col-2 t-align-left mgt-20">
                                                            <Button label={this.props.t("general.cancel")} className="p-3 w-full mt-auto p-button-danger" onClick={() => this.setState({generatePayment: false})}></Button>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            :
                                            <div className="col-2 t-align-left mgt-20">
                                                <Button label={this.props.t("finance.form.generate-payment")} className="p-3 w-full mt-auto" onClick={() => this.setState({generatePayment: true})}></Button>
                                            </div> 
                                    }
                                </>
                                : null
                            }
                            </div>
                    }
                </div>
                <div className='col-1'></div>
            </div>
            <Toast position='bottom-left' ref={this._toast} />
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
        associate: state.profile.associate,
        payments: state.finance.payments,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        mbPending: state.authentication.mbPending,
        mbwayPending: state.authentication.mbwayPending,
        generatedPaymentRef: state.finance.generatedPaymentRef,
        operation: state.finance.operation
  } 
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRegistrationPaymentList: (registrationRef) => { dispatch(getRegistrationPaymentList(registrationRef)) },
    getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) },
    updateGeneratedPaymentRef: (paymentRef) => { dispatch(updateGeneratedPaymentRef(paymentRef)) },
    updateFinanceOperationData: (data) => { dispatch(updateFinanceOperationData(data)) }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(FinancePage)));